import {Form} from "react-bulma-components";
import React from "react";


export default function VatSelector({onChange, value, name, disabled}){


    return (
        <Form.Select
            name={name}
            onChange={onChange}
            disabled={disabled}
            value={value}
          >
            <option key={"20"} value={20}>20%</option>
            <option key={"5"} value={5}>5%</option>
            <option key={"0"} value={0}>0%</option>
        </Form.Select>
    )
}